import * as React from 'react';
import classNames from 'classnames';

import { PhoneIcon } from '../../ui/icon/icons/phone';
import { formatPhone } from '../../utils/formatters';

import * as styles from './index.css';

interface ICallToActionProps {
  phone: string;
}

export class CallToAction extends React.Component<ICallToActionProps, object> {
  public render() {
    const { phone } = this.props;

    return (
      <div className={styles['container']}>
        <a href={`tel:+${phone}`} className={classNames(styles['phone-wrapper'], 'iefix_svg_wrapper')}>
          <PhoneIcon iconClassName={classNames(styles['phone-icon'], 'iefix_svg_icon')} />
          <span className={classNames(styles['phone'], 'iefix_color_main')}>{formatPhone(phone)}</span>
        </a>
      </div>
    );
  }
}
